import { GenData, QEq } from '@educraft/base';
import { Common, SimpleGenEq } from '../genHelper';

export const Addition = {
  single: (count = 2, min = 1, max = 20) => {
    return (r: any) => r.NN(count, min, max, (n: number[]) => n.reduce((a, b) => a + b, 0) <= max);
  },

  simple: (count = 2, min = 1, max = 100) => {
    return (r: any) => r.NN(count, min, max);
  },

  noCarry: (count: number, digits: number) => {
    return (r: any) => {
      const list: number[][] = [];
      for (let i = 0; i < digits; i++) {
        const arr = r.NN(
          count,
          i === 0 ? 1 : 0,
          9,
          (a: number[]) => a.reduce((sum, val) => sum + val, 0) <= 9
        );
        list.push(arr);
      }

      const nums = Array.from({ length: count }, (_, i) => {
        return list.reduce((acc, s) => acc * 10 + s[i], 0);
      });

      return nums;
    };
  },

  carry: (digits: number, count = 1) => {
    return (r: any) => {
      while (true) {
        const a: number[] = new Array(digits);
        const b: number[] = new Array(digits);

        const carryPositions = new Set(
          Array.from({ length: digits - 1 }, (_, i) => i + 1)
            .sort(() => r.nextDouble() - 0.5)
            .slice(0, count)
        );

        let carry = 0;

        for (let i = digits - 1; i >= 0; i--) {
          const mustCarry = carryPositions.has(i);
          const isMostSignificant = i === 0;

          let ai: number, bi: number;

          while (true) {
            ai = r.next(isMostSignificant ? 1 : 0, 10);

            if (mustCarry) {
              let minB = 10 - carry - ai;
              if (minB < 0) minB = 0;
              if (minB > 9) minB = 9;

              bi = r.next(minB, 10);

              if (isMostSignificant && ai + bi + carry >= 10) continue;
            } else {
              let maxB = 9 - carry - ai;
              if (maxB < 0) maxB = 0;

              bi = r.next(0, maxB + 1);
            }

            break;
          }

          a[i] = ai;
          b[i] = bi;
          carry = mustCarry ? 1 : 0;
        }

        const a1 = parseInt(a.join(''));
        const b1 = parseInt(b.join(''));

        if (a1 + b1 < 10**digits) {
          return [a1, b1];
        }
      }
    };
  },

  carrySingleDigit: (max: number) => {
    return (r: any) => {
      const arr = r.NN(
        3,
        0,
        9,
        (a: number[]) => a[1] + a[2] >= 10 && a[0] * 10 + a[1] + a[2] <= max
      );
      return [arr[0] * 10 + arr[1], arr[2]];
    };
  },
};

export class Math_Addition__To1000000__3Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(3, 1, 1000000)), 'Math_Addition__To1000000__3Numbers');
  }
}

export class Math_Addition__To1000000__4Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(4, 1, 1000000)), 'Math_Addition__To1000000__4Numbers');
  }
}

export class Math_Addition__To1000000__5Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(5, 1, 1000000)), 'Math_Addition__To1000000__5Numbers');
  }
}

export class Math_Addition__To1000000__Carry extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.carry(6)), 'Math_Addition__To1000000__Carry');
  }
}

export class Math_Addition__To1000000__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.noCarry(2, 6)), 'Math_Addition__To1000000__NoCarry');
  }
}

export class Math_Addition__To10000__3Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(3, 1, 10000)), 'Math_Addition__To10000__3Numbers');
  }
}

export class Math_Addition__To10000__4Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(4, 1, 10000)), 'Math_Addition__To10000__4Numbers');
  }
}

export class Math_Addition__To10000__5Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(5, 1, 10000)), 'Math_Addition__To10000__5Numbers');
  }
}

export class Math_Addition__To10000__Carry extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.carry(4)), 'Math_Addition__To10000__Carry');
  }
}

export class Math_Addition__To10000__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.noCarry(2, 4)), 'Math_Addition__To10000__NoCarry');
  }
}

export class Math_Addition__To1000__3Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(3, 1, 1000)), 'Math_Addition__To1000__3Numbers');
  }
}

export class Math_Addition__To1000__4Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(4, 1, 1000)), 'Math_Addition__To1000__4Numbers');
  }
}

export class Math_Addition__To1000__5Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(5, 1, 1000)), 'Math_Addition__To1000__5Numbers');
  }
}

export class Math_Addition__To1000__Carry extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.carry(3)), 'Math_Addition__To1000__Carry');
  }
}

export class Math_Addition__To1000__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.noCarry(2, 3)), 'Math_Addition__To1000__NoCarry');
  }
}

export class Math_Addition__To100__3Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(3, 1, 100)), 'Math_Addition__To100__3Numbers');
  }
}

export class Math_Addition__To100__4Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(4, 1, 100)), 'Math_Addition__To100__4Numbers');
  }
}

export class Math_Addition__To100__5Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(5, 1, 100)), 'Math_Addition__To100__5Numbers');
  }
}

export class Math_Addition__To100__Base extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(2, 1, 100)), 'Math_Addition__To100__Base');
  }
}

export class Math_Addition__To100__Carry extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.carry(2)), 'Math_Addition__To100__Carry');
  }
}

export class Math_Addition__To100__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.noCarry(2, 2)), 'Math_Addition__To100__NoCarry');
  }
}

export class Math_Addition__To10__Base extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(2, 1, 10)), 'Math_Addition__To10__Base');
  }
}

export class Math_Addition__To20__3Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(3, 1, 20)), 'Math_Addition__To20__3Numbers');
  }
}

export class Math_Addition__To20__4Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(4, 1, 20)), 'Math_Addition__To20__4Numbers');
  }
}

export class Math_Addition__To20__5Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(5, 1, 20)), 'Math_Addition__To20__5Numbers');
  }
}

export class Math_Addition__To20__Base extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(2, 1, 20)), 'Math_Addition__To20__Base');
  }
}

export class Math_Addition__To20__Carry extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.carrySingleDigit(20)), 'Math_Addition__To20__Carry');
  }
}

export class Math_Addition__To5__Base extends SimpleGenEq {
  constructor() {
    super(Common.plus(Addition.single(2, 1, 5)), 'Math_Addition__To5__Base');
  }
}
